import settings from '../settings';

import $ from 'jquery';
import sweetalert from 'sweetalert';

import nunjucks from 'nunjucks';
import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();
import moment   from 'moment';

export default class Statistics {

    constructor() {

        this.click__ajax = this.click__ajax.bind(this);
        this.click__paginate = this.click__paginate.bind(this);

        this.init();
    }

    click__ajax(ev) {

        let $me = $(ev.currentTarget),
            request;
        let $table = $('#'+$me.data('table'));
        let $tables = "";
        if($me.data('table')=="impressiontable" || $me.data('table')=="engagmenttable"){
            $tables = $('#table_container_2');
        }else{
            $tables = $('#table_container');
        }
        

        let more_value = $me.data('moreparam');


        if ($me.data('enabled')) {
            $table.hide();
            $me.addClass('btn--primary');
            $me.text('View More');
            $me.data('enabled', false);
        } else {

            $me.removeClass('btn--primary');
            $me.text('Loading...');
            $me.data('enabled', true);

            request = $.ajax({
                headers: settings.api_headers,
                url: $me.data('url'),
                type: 'GET',
                dataType: 'json',
                data: {more: more_value}
            });

            request.done((data, textStatus, jqXHR) => {

                $('tbody', $table).remove();
                $table.detach();
                $tables.prepend($table);
                $table.show();
                $me.removeClass('btn--primary');
                $me.text('View Less');
                $me.data('enabled', true);

                $('thead', $table).after(
                    nunjucksEnv.render(
                        'html/leaderboard/more.html',
                        {
                            data : data,
                            name: $me.data('name'),
                            active_user_count: parseInt($('.number-of-active-users').text())
                        }
                    )
                );
            });
        }
    }

    click__paginate(ev) {
      ev.preventDefault();

      let $users = $(ev.delegateTarget),
          $list = $users.find('.leaderboard__body'),
          $me = $(ev.currentTarget),
          $parent = $me.parents('.leaderboard__footer'),
          post,
          request = $.ajax({
            headers: settings.api_headers,
            url: $me.data('base-url'),
            data: { page : $me.data('next-page') },
            type: 'GET',
            dataType: 'json'
          });

      request
        .always(function(jqXHR, textStatus) {
          var next_page = $me.data('next-page') + 1;

          $me.data('next-page', next_page);
          if ($me.data('max-pages') < next_page) {
            $parent.hide();
          } else {
            $parent.show();
          }
        })
        .done(function(data, textStatus, jqXHR) {
          $.each(data.leaderboard, function(k, v) {
            v.position = $users.find('.leaderboard__body tr').length + 1;
            v.current_user_id = $('.user-profile').data('user-id');

            var user = $(nunjucksEnv.render('html/leaderboard/user.html', v));
            user.addClass('is-new');

            $list.append(user);
          });
        });
    }

    init() {
        $('body')
            .on('click', '.viewmore--ajax', this.click__ajax);

        $('.statistics')
            .on('click', '.leaderboard__footer a', this.click__paginate);
    }
}
